module.exports = "/_next/static/images/594e03928cb79ec8f89c1a922c05760c-two-people-looking-md@3x.jpg.webp";